// extracted by mini-css-extract-plugin
module.exports = {"placeholder_list":"EditPagePreview_placeholder_list__skySO"};